import React from "react";


export default function Map({ property = {} }) {
  const isPhotosPresent = Boolean(property?.photos?.length);

  return (
    <>
      <div
        className="modal fade"
        id="exampleModal3"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel3"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-info" id="exampleModalLabel3">
                Welcome Members
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <img
                alt="property"
                  style={{ objectFit: "cover" }}
                  src={isPhotosPresent ? property?.photos[0]?.url : "/resturant.jfif"}
                  height={250}
                  width={500}
                />
                <p className="mt-5 mb-n2">Join our exclusive members club and</p>
                <p>reward yourself with an additional discount in all our rates</p>
                {property?.email && (
                  <p>
                    Contact <b>{property?.email}</b>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
